import {
  Dialog,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useAdRevertModal } from '../hooks/useAdRevertModal';
import type { AdRevertModalProps } from '../types';

const DIALOG_PAPER_SX = { width: 600, maxHeight: '80%', margin: 0 } as const;

export const AdRevertModal = ({ onClose }: AdRevertModalProps) => {
  const { title, loadingTitle, loadingText } = useAdRevertModal({ onClose });

  return (
    <Dialog
      id="adRevertModal"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      // Revert is local + instant; the modal closes itself via the hook's
      // visual-delay timer, so backdrop clicks are intentionally inert.
    >
      <DialogTitle id="ad-revert-modal-title" showClose={false}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogMessageBox
          id="ad-revert-modal-loading"
          title={loadingTitle}
          type="loading"
          text={loadingText}
        />
      </DialogContent>
    </Dialog>
  );
};
